/* tslint:disable */
/* This file was generated by @citrite/translate. Manual changes will be lost. */
import { Language } from '@citrite/translate';
export type locale = 'de' | 'en' | 'es' | 'fr' | 'it' | 'ja' | 'nl' | 'pt-BR';
export const languages: Language[] = [
  {
    "key": "de",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "en",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {<item>}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The {<name>} integration's features are now available to users on your account.",
              "message": "Installed integration"
            },
            "solution": {
              "description": "The {<name>} solution's features are now available to users on your account.",
              "message": "Installed solution"
            },
            "template": {
              "description": "{<name>} is now available in the \"Installed templates\" section of templates.",
              "message": "Installed template"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {<item>}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Uninstalled integration"
            },
            "solution": {
              "message": "Uninstalled solution"
            },
            "template": {
              "message": "Uninstalled template"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {<item>}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Browse Catalog",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "es",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "fr",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "it",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "ja",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integrations",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solutions",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "template": "Templates",
        "template_description": "Get started faster with industry specific templates for common project structures and documents."
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "nl",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  },
  {
    "key": "pt-BR",
    "content": {
      "AddOrUpdateProject": {
        "cancel": "Cancel",
        "create": "Create"
      },
      "CreateProject": {
        "title": "Create Project"
      },
      "alerts": {
        "hipaa_warning_alert": "On ensuring safety for HIPAA enabled third party connection management",
        "hipaa_warning_message": "This feature may require ShareFile to transfer your data to unaffiliated third party apps. By enabling or using it, you authorize such transfers. ShareFile does not have an agreement with any third party app developers, and cannot control what happens to your data once it leaves ShareFile's system. You are responsible for determining the necessity of, and entering into any required agreements, as well as ensuring all such transfers are compliant with applicable law."
      },
      "catalog_types": {
        "integration": "Integration",
        "integration_description": "Expand ShareFile’s capabilities with integrations into other applications. Connect ShareFile to any service you may use to get more done than ever before.",
        "integration_plural": "Integrations",
        "menu_button_label": "Catalog types menu button",
        "menu_label": "Catalog types menu",
        "solution": "Solution",
        "solution_description": "ShareFile solutions allow you to create custom tailored spaces to meet your needs. Fully transform your ShareFile workflow and get more done.",
        "solution_plural": "Solutions",
        "template": "Template",
        "template_description": "Get started faster with industry specific templates for common project structures and documents.",
        "template_plural": "Templates"
      },
      "categories": {
        "accounting": "Accounting",
        "all": "All",
        "construction": "Construction",
        "finance": "Finance",
        "healthcare": "Healthcare",
        "integrations": "Integrations",
        "legal": "Legal",
        "manufacturing": "Manufacturing",
        "real_estate": "Real Estate"
      },
      "common": {
        "back": "Back",
        "cancel": "Cancel",
        "continue": "Continue",
        "details": "Details",
        "filters": "Filters",
        "manage": "Manage",
        "packages": "Packages",
        "search": "Search"
      },
      "details": {
        "created_by": "Created by",
        "industry": "Industry",
        "industry_filter_label": "Filter by industry",
        "name": {
          "generic": "Name",
          "integration": "Integration name",
          "solution": "Solution name",
          "template": "Template name"
        },
        "overview": "Overview",
        "published": "Published",
        "publisher": "Publisher",
        "version": "Version"
      },
      "filters": {
        "enableDelete": "Enable Delete",
        "showInstalledOnly": "Show only installed",
        "sort": {
          "sortBy": {
            "label": "Sort by",
            "values": {
              "name": "Name",
              "publishDate": "Publish Date"
            }
          },
          "sortOrder": {
            "label": "Sort order",
            "values": {
              "nameASC": "A-Z",
              "nameDESC": "Z-A",
              "publishDateASC": "Oldest",
              "publishDateDESC": "Newest"
            }
          }
        }
      },
      "masthead": {
        "back_to_sharefile": "Back to ShareFile",
        "catalog": "Catalog",
        "solutions_catalog": "ShareFile catalog"
      },
      "messages": {
        "configure": {
          "integration": "The {<name>} integration must be configured before it can be used.",
          "item": "The {{item}} must be configured before it can be used.",
          "solution": "The {<name>} solution must be configured before it can be used.",
          "template": "The {<name>} template must be configured before it can be used."
        },
        "delete": {
          "confirmation": {
            "description": {
              "generic": "Are you sure you want to delete this?",
              "solution": "Are you sure you want to delete {{solution}}?"
            },
            "title": "Delete this?"
          },
          "failure": {
            "generic": {
              "message": "Failed to delete"
            },
            "integration": {
              "message": "Failed to delete integration"
            },
            "solution": {
              "message": "Failed to delete solution"
            },
            "template": {
              "message": "Failed to delete template"
            }
          },
          "label": {
            "generic": "Delete",
            "item": "Delete {{item}}",
            "item_by_author": "Delete {{item}} by {{author}}"
          },
          "success": {
            "generic": {
              "message": "Deleted successfully"
            },
            "integration": {
              "message": "Integration deleted"
            },
            "solution": {
              "message": "Solution deleted"
            },
            "template": {
              "message": "Template deleted"
            }
          }
        },
        "entitlements": {
          "generic": "An entitlement error has occurred. Please contact your administrator",
          "tryfree": "Try free",
          "tryfree_item_by_author": "Try {{item}} by {{author}} for free",
          "upgradeplan": "Upgrade plan"
        },
        "error": {
          "generic": "An error occurred",
          "load_failure": {
            "generic": "Error loading data",
            "item": "Could not load {{item}}"
          },
          "not_found": {
            "generic": "Not found",
            "item": "No {{item}} found"
          },
          "unavailable": {
            "generic": "Unavailable",
            "item": "{{item}} unavailable"
          }
        },
        "info": {
          "end_of_list": {
            "generic": "You've loaded all items",
            "items": "You've loaded all {{items}}"
          }
        },
        "install": {
          "client_portal_disclaimer": {
            "documentation": "documentation",
            "message1": "Before you proceed with the installation, please note:",
            "message2": "By installing this update, all client users will be transitioned to the new client portal experience. This change is designed to improve usability throughout the service interaction.",
            "message3": "We recommend reviewing the new client portal experience in our {<documentation>} to familiarize yourself with the changes. Should you or your users have any questions or require support, please do not hesitate to contact our support team.",
            "title": "Welcome to the new client portal experience!"
          },
          "confirmation": {
            "generic": "Would you like to install this?",
            "item": "Would you like to install {{item}}?"
          },
          "entitlements": {
            "generic": "You do not have the necessary entitlements to install this."
          },
          "failure": {
            "generic": {
              "description": "There was an error during the installation. Please try again.",
              "message": "Installation failure"
            },
            "integration": {
              "description": "There was an error installing this integration. Please try again.",
              "message": "Integration not installed"
            },
            "solution": {
              "description": "There was an error installing this solution. Please try again.",
              "message": "Solution not installed"
            },
            "template": {
              "description": "There was an error installing this template. Please try again.",
              "message": "Template not installed"
            }
          },
          "in_progress": {
            "integration": "Installing the {<name>} integration...",
            "solution": "Installing the {<name>} solution...",
            "template": "Installing the {<name>} template..."
          },
          "installed": "Installed",
          "label": {
            "generic": "Install",
            "integration": "Install integration",
            "item": "Install {{item}}",
            "item_by_author": "Install {{item}} by {{author}}",
            "solution": "Install solution",
            "template": "Install template"
          },
          "success": {
            "generic": {
              "action": "Take me there",
              "message": "Installed successfully"
            },
            "integration": {
              "description": "The integration's features are available in your account now.",
              "message": "Integration installed"
            },
            "solution": {
              "description": "The solution's features are available in your account now.",
              "message": "Solution installed"
            },
            "template": {
              "description": "{<name>} is now available in the \"Shared with me\" section of templates.",
              "message": "Template installed"
            }
          }
        },
        "reinstall": {
          "confirmation": {
            "generic": "Would you like to reinstall this?",
            "item": "Would you like to reinstall {<item>}?"
          },
          "label": {
            "generic": "Reinstall",
            "item": "Reinstall {{item}}",
            "item_by_author": "Reinstall {{item}} by {{author}}"
          }
        },
        "request": {
          "failure": {
            "generic": {
              "description": "Your request could not be sent to your administrator. Try again later.",
              "message": "Request failed to send"
            }
          },
          "form": {
            "comments": "Comments",
            "send_copy_to_sender": "Send me a copy of this email"
          },
          "info": "This request will go to your administrator for approval.",
          "label": {
            "generic": "Request",
            "integration": "Request integration",
            "item": "Request {{item}}",
            "item_by_author": "Request {{item}} by {{author}}",
            "solution": "Request solution",
            "template": "Request template"
          },
          "success": {
            "generic": {
              "description": "Your request for {<name>} has been sent to your administrator.",
              "message": "Request sent"
            }
          },
          "tooltip": {
            "install": "Reach out to your Admin and request install.",
            "reinstall": "Reach out to your Admin and request re-install.",
            "settings": "Reach out to your Admin and request settings updates.",
            "uninstall": "Reach out to your Admin and request uninstallation.",
            "upgrade": "Reach out to your Admin and request upgrade."
          }
        },
        "settings": {
          "label": {
            "generic": "Settings",
            "item_by_author": "Settings for {{item}} by {{author}}"
          }
        },
        "uninstall": {
          "confirmation": {
            "generic": "Are you sure you want to uninstall this?",
            "item": "Are you sure you want to uninstall {{item}}?",
            "purge_data": "Also delete all of this solution's data"
          },
          "failure": {
            "generic": {
              "description": "There was an error during the uninstallation. Please try again.",
              "message": "Uninstallation failure"
            },
            "integration": {
              "description": "There was an error uninstalling this integration. Please try again.",
              "message": "Integration not uninstalled"
            },
            "solution": {
              "description": "There was an error uninstalling this solution. Please try again.",
              "message": "Solution not uninstalled"
            },
            "template": {
              "description": "There was an error uninstalling this template. Please try again.",
              "message": "Template not uninstalled"
            }
          },
          "in_progress": {
            "integration": "Uninstalling the {<name>} integration...",
            "solution": "Uninstalling the {<name>} solution...",
            "template": "Uninstalling the {<name>} template..."
          },
          "label": {
            "generic": "Uninstall",
            "item": "Uninstall {{item}}",
            "item_by_author": "Uninstall {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request uninstallation.",
          "success": {
            "generic": {
              "message": "Uninstalled successfully"
            },
            "integration": {
              "message": "Integration uninstalled successfully"
            },
            "solution": {
              "message": "Solution uninstalled successfully"
            },
            "template": {
              "message": "Template uninstalled successfully"
            }
          },
          "uninstalled": "Uninstalled"
        },
        "update": {
          "available": {
            "generic": "Update available",
            "item": "Update available for {{item}}",
            "message": "There is a new version of this {{item}} available. Your installed version is {<installedVersion>} and the newest version is {<latestVersion>}. To use the newest version, you will need to uninstall and then reinstall this {{item}}.",
            "message2": "There is an update available. Your current version is {<installedVersion>} and the latest is {<latestVersion>}"
          },
          "confirmation": {
            "generic": "Are you sure you want to update this?",
            "item": "Are you sure you want to update {{item}}?"
          },
          "failure": {
            "generic": {
              "message": "Update failure"
            },
            "integration": {
              "description": "There was an error updating this integration. Please try again.",
              "message": "Failure updating integration"
            },
            "solution": {
              "description": "There was an error updating this solution. Please try again.",
              "message": "Failure updating solution"
            },
            "template": {
              "description": "There was an error updating this template. Please try again.",
              "message": "Failure updating template"
            }
          },
          "in_progress": {
            "integration": "Updating the {<name>} integration...",
            "solution": "Updating the {<name>} solution...",
            "template": "Updating the {<name>} template..."
          },
          "label": {
            "generic": "Update",
            "item": "Update {{item}}",
            "item_by_author": "Update {{item}} by {{author}}"
          },
          "request": "Reach out to your Admin and request upgrade.",
          "success": {
            "generic": {
              "message": "Updated successfully"
            },
            "integration": {
              "description": "{<name>} has been updated.",
              "message": "Integration updated"
            },
            "solution": {
              "description": "{<name>} has been updated.",
              "message": "Solution updated"
            },
            "template": {
              "description": "{<name>} has been updated.",
              "message": "Template updated"
            }
          }
        },
        "useTemplate": {
          "label": {
            "generic": "Use template"
          }
        }
      },
      "registry": {
        "label": "Registry"
      },
      "releaseTags": {
        "alpha": "Alpha",
        "beta": "Beta",
        "prerelease": "Pre-release"
      },
      "titles": {
        "dashboard": "Solutions",
        "details": {
          "generic": "Details",
          "item": "{{item}} details"
        },
        "navbar": "Catalog"
      }
    }
  }
];